<template>
	<b-table
		:class="{ fullHeight: isSimpleCRUD }"
		striped
		hover
		sticky-header
		responsive
		small
		:items="tblItems"
		:fields="tblFields"
		:is-radio="true"
		:selected="selectedParent"
		head-variant="dark"
	>
		<template #cell(select)="row">
			<input
				type="radio"
				:checked="selectedParent == row.item.data.idSupplier"
				:value="row.item"
				@click="$emit('actionSelectParent', row.item.data)"
				style="margin-top: 12px; transform: scale(1.2)"
			/>
		</template>
		<template #cell(actions)="row">
			<k-icon-button
				v-if="row.item.actions.rehomologation"
				:disabled="!userPermissions.update"
				@click="$emit('actionRehomologation', row.item.data)"
			>
				<template v-slot:content>
					<b-iconstack font-scale="1"> </b-iconstack>
				</template>
			</k-icon-button>
		</template>
		<template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
			<slot :name="slot" v-bind="scope" />
		</template>
	</b-table>
</template>

<script>
import KIconButton from "./Buttons/KIconButton.vue";
import ModalMixin from "@/mixins/ModalMixin";
import { mapGetters } from "vuex";

export default {
	components: { KIconButton },
	mixins: [ModalMixin],
	props: {
		items: {
			type: Array,
			required: true
		},
		fields: {
			type: Array,
			default: () => [],
			required: true
		},
		isSimpleCRUD: {
			type: Boolean,
			default: false
		},
		isRadio: {
			type: Boolean,
			default: true
		},
		selected: {
			type: Number,
			default: 0
		}
	},
	computed: {
		...mapGetters(["userPermissions"]),
		tblItems: function () {
			let response = [];
			this.items.forEach((item) => {
				let obj = {};

				this.fields.forEach((field) => {
					if (field.getProp) {
						obj[field.key] = field.getProp(item, this.$store.state);
					} else {
						obj[field.key] = item[field.key];
					}
				});

				obj["data"] = item;
				obj["actions"] = {
					expand: false,
					edit: false,
					exclude: false,
					insert: false,
					inactive: false,
					view: false,
					...item["actions"]
				};
				response.push(obj);
			});

			return response;
		},
		tblFields: function () {
			return [
				{ key: "select", label: "", class: "text-center" },
				{ key: "actions", label: "", class: "text-right" },
				...this.fields
			];
		},
		radioButtonInfo: function () {
			return this.isRadio;
		},
		selectedParent: function () {
			if (this.selected != null) {
				return this.selected;
			} else return 0;
		}
	}
};
</script>

<style>
.fullHeight {
	max-height: calc(100% - 100px);
}
.b-table-sticky-header > .table.b-table > thead > tr > th {
	position: sticky !important;
}
</style>
